import React, { useState } from 'react'
import {
    FormControl,
    Stack,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
    Menu,
    Button,
    useTheme
} from "@mui/material";
import FilterButtons from './FilterButtons';
import { styled, alpha } from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme, width }) => ({
    '& .MuiPaper-root': {
        borderRadius: 4,
        marginTop: 16,
        minWidth: width ||'12%',
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            '0px 3px 6px #00000029;',
        '& .MuiMenu-list': {
            padding: '0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


export default function RadioButtonFilter({ headData, onChange }) {
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectValue, setValue] = useState(headData?.filter?.selectValue ? headData.filter.selectValue : null);
    const handleRadioChange = (event) => {
        setValue(event.target.value);
    };

    const handleSubmit = (btntype) => {
        const updateObj = headData;
        updateObj.filter.selectValue = btntype === 'Reset' ? null : selectValue;
        onChange({ ...updateObj });
        handleClose();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDropDownClick = (event) => {
        setAnchorEl(event.currentTarget);
        setValue(headData?.filter?.selectValue || null);
    };

    return (
        <>
            <Button
                style={{
                    background: headData?.filter?.selectValue ? theme.palette.primary.main : '',
                    color: headData?.filter?.selectValue ? theme.palette.background.main : '',
                }}
                className='!p-[0px] !min-w-[23px] !w-[23px] !h-[23px] !mr-[10px]' onClick={(event) => {
                    handleDropDownClick(event);
                }}
            >
                <ArrowDropDownIcon />
            </Button>

            <StyledMenu
                id="filter-list-menu-checkBox"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                width={headData?.width}
                open={open}
                onClose={handleClose}
            >

                <FormControl variant="standard" className='!block'>
                    <RadioGroup
                        className='!py-[8px]'
                        name="quiz"
                        value={selectValue}
                        onChange={handleRadioChange}
                    >
                        {headData?.filter?.filterList.map((data, index) => {
                            return (
                                <FormControlLabel
                                    className='!mx-[0px] !h-[24px] !justify-between !px-[10px]'
                                    value={data.id}
                                    control={<Radio sx={{
                                        "& .MuiSvgIcon-root": {
                                            height: 18,
                                            width: 18,
                                        }
                                    }} className='!p-[0px]' />}
                                    label={<Typography className='!text-[12px]'>{data.name}</Typography>}
                                    labelPlacement="start"
                                    key={index}
                                    style={{ background: selectValue === data.id ? 'rgba(232, 245, 253, 1)' : '' }}
                                />
                            )
                        })}
                    </RadioGroup>
                    <Stack direction="row" sx={{ borderTop: 'solid 0.01px #cecccc'}} spacing={1} className='!px-[6px] !py-[12px] !justify-around'>
                        <FilterButtons name={`Reset`} onClick={(btnType) => { handleSubmit(btnType) }} />
                        <FilterButtons disabled={!selectValue} name={`Apply`} onClick={(btnType) => { handleSubmit(btnType) }} />
                    </Stack>
                </FormControl>

            </StyledMenu>
        </>
    )
}
